<!--
 * @Description: 文件预览组件
 * @Author: fal
 * @FilePath: \pc.ui\src\project\components\filePreview.vue
 * @LastEditTime: 2025-03-20 14:21:44
-->
<template>
  <div v-if="list.length > 0">
    <div v-for="(item, index) in list" style="display: inline-block" :key="index">
      <el-image
        :src="item"
        v-if="findType(item) == 'image'"
        fit="cover"
        :preview-src-list="list.filter((item) => findType(item) == 'image').map((item) => item)"
        :style="imageStyle"
      />
      <video autopay :src="item.url" v-else-if="findType(item) == 'video'" :style="imageStyle"></video>
      <img v-else-if="findType(item) == 'xlsx'" src="@/project/assets/file/xlsx.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'txt'" src="@/project/assets/file/txt.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'doc'" src="@/project/assets/file/doc.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'docx'" src="@/project/assets/file/docx.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'zip'" src="@/project/assets/file/zip.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'xls'" src="@/project/assets/file/xls.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'rar'" src="@/project/assets/file/rar.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'pdf'" src="@/project/assets/file/pdf.png" :style="imageStyle" />
      <img v-else-if="findType(item) == 'dwg'" src="@/project/assets/file/dwg.png" :style="imageStyle" />
      <img v-else src="@/project/assets/file/unknown.png" :style="imageStyle" />
    </div>
  </div>
</template>

<script>
import { findType } from '@/project/utils/file.js';
export default {
  name: 'filePreview',
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    size: {
      type: Number,
      default: 100,
    },
    spacing: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {};
  },
  computed: {
    imageStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        marginRight: `${this.spacing}px`,
        marginBottom: `${this.spacing}px`,
        borderRadius: '6px',
        border: '1px solid #e5e5e5',
        display: 'inline-block',
      };
    },
  },
  methods: {
    findType(item) {
      return findType(item);
    },
  },
};
</script>
